import ajax from './index'

//获取小店活动列表
export function activitySearchList(url){
   return ajax.get('/admin/activity/search?'+url)
}
//小店活动详情
export function activityDetail(url,activityId){
  return ajax.get('/admin/activity/'+activityId+'/detail?',url)
}
//删除小店活动
export function activityDeleteType(data,activityId){
  return ajax.post('/admin/activity/' + activityId+'/delete', data)
}

//下架活动
export function activityDownData(activityId,data){
  return ajax.post('/admin/activity/ongoing_activity/'+activityId+'/down',data)
}

//营销插件列表
export function activityMarketToolData(){
  return ajax.get('/admin/activity/marketing_tool/search')
}

//营销插件编辑 
export function   activityMarketToolUpdate(id,data){
  return ajax.post('/admin/activity/marketing_tool/'+id+'/update', data)
}

// 活动列表模块
export function getActivityList() {
  return ajax.get('/admin/activity/supply/search')
}

// 活动列表模块添加/编辑弹窗
export function activityAddEdit(data) {
  return ajax.post('/admin/activity/supply/create',data)
}
// 活动列表模块删除
export function activityDelete(data) {
  return ajax.post('/admin/activity/supply/del',data)
}
// 活动分类配置列表模块列表数据
export function getClassfyActivityList() {
  return ajax.get('/admin/activity/classification/search')
}

// 活动分类配置列表模块添加/编辑弹窗
export function activityClassfyAddEdit(data) {
  return ajax.post('/admin/activity/classification/create ', data)
}

// 活动分类配置列表模块添加/编辑弹窗
export function activityClassfyDelete(data) {
  return ajax.post('/admin/activity/classification/del ', data)
}